import { render } from "./Periods.vue?vue&type=template&id=5f546ed4&ts=true"
import script from "./Periods.vue?vue&type=script&lang=ts"
export * from "./Periods.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__